// special JS for the takeover menu

(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.pacs_takeover = {

    activateTakeover: function(type, button, cover) {
      const pacsTakeover = Drupal.behaviors.pacs_takeover;

      // takeoverMenu icon change
      button.addEventListener('click', function() {
        pacsTakeover.toggleTakeover(type, button, cover);
      });

      document.addEventListener('keydown', function(e) {
        if (e.code == 'Enter' && e.target == button) {
          pacsTakeover.toggleTakeover(type, button, cover);
        }
        if (e.code == 'Escape' && pacsTakeover.checkOpen(type)) {
          pacsTakeover.toggleTakeover(type, button, cover);
        }
      });

      // actions when takeoverCover clicked
      if (cover) {
        cover.addEventListener('click', function() {
          pacsTakeover.toggleTakeover(type, button, cover);
        });
      }
    },

    checkClosed: function(type) {
        if (document.querySelector('body').classList.contains('takeover-' + type + '-open')) {
            return false;
        }
        return true;
    },

    checkOpen: function(type) {
        if (document.querySelector('body').classList.contains('takeover-' + type + '-open')) {
            return true;
        }
        return false;
    },

    toggleTakeover: function(type, button, cover) {
      const pacsTakeover = Drupal.behaviors.pacs_takeover;

      const body = document.querySelector('body');
      let takeover = document.getElementById('takeover-' + type);
      let toggleButtons;
      let icon;

      // ensure all other takeovers are closed
      switch (type) {
        case 'menu':
          toggleButtons = document.querySelectorAll('#takeover-buttons a');
          icon = 'bars';
                      
          break;
  
      }

      // animate icon
      // Drupal.behaviors.weaver_animations.morphIcons(icon, 'close');

      // expand/collapse menu
      body.classList.toggle('takeover-' + type + '-open');
      body.classList.toggle('takeover-' + type + '-closed');

      // take care of accessibility
      this.toggleTrueFalse(takeover, 'aria-hidden');
      toggleButtons.forEach((toggleButton) => {
        this.toggleTrueFalse(toggleButton, 'aria-expanded');
      });

      // close tooltips
      $('[data-toggle="tooltip"]').tooltip('hide');
      
      this.trapFocus(type);
    },

    toggleTrueFalse: function(element, attribute) {

        let attributeStatus = element.getAttribute(attribute);

        if (attributeStatus == 'true') {
          element.setAttribute(attribute, 'false');
        } else {
          element.setAttribute(attribute, 'true');
        }
    },

    trapFocus: function(type) {

      const takeoverMenuLinks = document.getElementById('takeover-menu').querySelectorAll('a');

      // put all menu items into or out of tabindex
      if (this.checkOpen(type)) {

        switch (type) {

          case 'menu':

            takeoverMenuLinks.forEach((link) => {
                link.setAttribute('tabindex', 0);
            });

            break;
        }

      } else {

        switch (type) {

          case 'menu':
            takeoverMenuLinks.forEach((link) => {
                link.setAttribute('tabindex', -1);
            });

            break;
        }
      }
    },

    attach: function (context, settings) {

        // ensures javascript runs only once per page load and not with every ajax call
      $(once('pacs_takeover', 'body', context)).each(function () {
        	
        const pacsTakeover = Drupal.behaviors.pacs_takeover;

        // add closed classes
        const body = document.querySelector('body');
        body.classList.add('takeover-menu-closed');

        // make all takeover links tabindex -1
        pacsTakeover.trapFocus('menu');

        // MENU
        let takeover = document.getElementById('takeover-menu');
        let takeoverButtons = document.querySelectorAll('a[data-target="#takeover-menu"]');
        let takeoverCover = document.getElementById('takeover-cover');
        let closeButton = document.getElementById('takeover-close');

      	if (takeover) {

          var tabHandle;
      		if (takeoverButtons) {

            takeoverButtons.forEach((takeoverButton) => {
              pacsTakeover.activateTakeover('menu', takeoverButton, takeoverCover);

              takeoverButton.addEventListener('click', function() {
                if (tabHandle) {
                  tabHandle.disengage();
                  tabHandle = null;
                } else {
                  tabHandle = ally.maintain.tabFocus({
                    context: takeover
                  });
                }
              });
            });
          }

          // #TODO make more elegant and DRY
          // but can't get tabHandle to pass through functions
          if (takeoverCover) {
            takeoverCover.addEventListener('click', function() {
              if (tabHandle) {
                tabHandle.disengage();
                tabHandle = null;
              } else {
                tabHandle = ally.maintain.tabFocus({
                  context: takeover
                });
              }
            });
          }
      	}

      });
    }
  };

})(jQuery, Drupal, once);
